import { containerStyle } from '../../styles';

export default {
  container: {
    ...containerStyle
  },
  codeSentLabel: {
    textAlign: 'center',
    whiteSpace: 'nowrap',
    paddingBottom: 20
  },
  submit: {
    textTransform: 'uppercase',
    marginTop: 20
  },
  signOut: {
    marginTop: 20,
    textDecoration: 'none'
  },
  noShrink: {
    height: 60,
    minWidth: 310,
    flexShrink: 0
  }
};
